// src/components/Badge.js
import React from 'react';

export default function Badge({ children }) {
  const text = String(children);

  return (
    <span
      className="
        inline-flex items-center
        max-w-full
        whitespace-nowrap
        px-3 py-1
        rounded-full
        border border-emerald-400/40
        bg-emerald-500/10
        text-emerald-200
        font-medium
        leading-none
      "
      style={{
        fontSize:
          text.length > 12
            ? '0.65rem'
            : text.length > 8
            ? '0.7rem'
            : '0.75rem',
      }}
    >
      {children}
    </span>
  );
}
